import React from 'react';
import {
    Select, MenuItem, Grid, Button, FormControl, InputLabel
} from '@material-ui/core';
import { Form, Field } from 'react-final-form';
import FormInput from '+/components/MUITextField';
import { useCreateUnitTypeGrouping } from '~/groupings';

const GroupingForm = props => {
    const {
        data, handleClose, initialValues
    } = props;

    const { mutate: createGrouping } = useCreateUnitTypeGrouping();

    const onSubmit = values => {
        values.unitTypes = (values.unitTypes || []).map(({ id }) => ({ id }));

        createGrouping(values);
        handleClose();
    };

    const unitTypes = data.availableGroupings.concat(initialValues.unitTypes || []);

    return (
        <div style={{ height: '200px' }}>

            <Form
                onSubmit={onSubmit}
                initialValues={initialValues}
                render={({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={3} justifyContent='flex-end'>
                            <Grid item xs={12}>
                                <FormInput name='name' label='Name' />
                            </Grid>

                            <Grid item xs={12}>
                                <Field name='unitTypes'>
                                    {({ input }) => (
                                        <FormControl fullWidth>
                                            <InputLabel>Unit Types</InputLabel>
                                            <Select
                                                {...input}
                                                label='Unit Types'
                                                multiple
                                                value={input.value || []}
                                            >
                                                {unitTypes.map(
                                                    unitType => (
                                                        <MenuItem value={unitType} key={unitType.id}>
                                                            {unitType.name}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </FormControl>
                                    )}
                                </Field>
                            </Grid>
                            <Grid item>
                                <Button onClick={handleClose}>
                                    Cancel
                                </Button>
                                <Button type='submit'>Submit</Button>
                            </Grid>
                        </Grid>
                    </form>
                )}
            />
        </div>
    );
};

export default GroupingForm;
